<template>
  <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('steps.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <Button v-if="$can(abilities.CREATE_MILESTONE)" btn-class="btn-sm" type="new" btn-text="steps.create" @click="openStepModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_steps" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-200px">{{ $t('steps.title')}}</th>
              <th class="min-w-100px">{{ $t('steps.color')}}</th>
              <th class="w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <StepModal id="create-step-modal" @load="fetchDatas"/>
    <StepModal id="edit-step-modal" :form="formUpdateData" @load="fetchDatas" :edit="true"/>
</template>

<script setup>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import {$formatLocalAmount} from "@/mixins/Helpers"
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import StepModal from "../../../components/Modals/StepModal"

const {showSwal} = useSwal()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { can } = useHasAbility()

const table = ref()

const formUpdateData = ref({
  id:'',
  title: "",
  color: "#000",
  status: [],
  milestone_progress: 0,
  default: false
})

onMounted(() => {
  fetchDatas()
})

watch(() => locale.value, () => {
  nextTick(() => fetchDatas() )
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#kt_datatable_steps").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'asc']],
    ajax: {
      url: BASE_URL + "/milestone-categories/datatables",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "title" },
      { data: "color" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -3,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t) {
          return '<span >' + t + "</span>";
        },
      },
      {
        targets: -2,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<div style="width: 50%; border: 8px solid ' + e.color + '; border-radius: 5px; background-color: ' + e.color + '" data-id="'+ e.id +'"></div>';
        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(can(abilities.UPDATE_MILESTONE)){
            render+='<a data-id="'+ e.id +'" data-title="'+ e.title +'" data-color="'+ e.color +'" data-status="'+ e.statusId +'" data-default="'+ e.default +'" data-progress="'+ e.milestone_progress +'"  href="javascript:;"   class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'" data-title="'+ e.title +'" data-color="'+ e.color +'" data-status="'+ e.statusId +'" data-default="'+ e.default +'" data-progress="'+ e.milestone_progress +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'" ></i></a>'
          }
          if(can(abilities.DELETE_MILESTONE)){
            render += '<a data-id="'+ e.id +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  table.value.on("click", ".edit_btn", (e) => {
    formUpdateData.value.id = e.target.getAttribute('data-id')
    formUpdateData.value.title = e.target.getAttribute('data-title')
    formUpdateData.value.color = e.target.getAttribute('data-color')
    formUpdateData.value.default = e.target.getAttribute('data-default') == 'true' ? true : false
    formUpdateData.value.milestone_progress = e.target.getAttribute('data-progress')
    formUpdateData.value.status = e.target.getAttribute('data-status').split(',') || [];

    $('#edit-step-modal').modal('toggle')
  });

  table.value.on("click", ".delete_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    deleteStep(id)
  });
}

function openStepModal() {
  $('#create-step-modal').modal('toggle')
}

async function deleteStep(id) {
    showSwal(
        '',
        i18n.global.t('steps.step_deleted')
    ).then( async (result) => {
        if (result.value) {
            try {
                await store.dispatch('milestoneCategories/deleteTaskMilestone', id)
                table.value.ajax.reload()
                window.toastr['success'](i18n.global.t("steps.deleted_successfully"))
            }catch (e) {
            }
        }
  })
}
</script>
